import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";
import AddRfDeviceMaster from "./AddRfDeviceMaster";

class RfDeviceMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      rfDeviceData: [],
      count: 10,
    };
  }
  componentDidMount() {
    this.getRfDeviceMasterData();
    const {companyId} = this.props;
    const data = {
      companyId: companyId
    }
    this.props.getMoves(data);
  }

  getRfDeviceMasterData() {
    const { dispatch, companyId,branchId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&branchId=${branchId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_RF_DEVICE_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ rfDeviceData: res && res});
      },
    });
  }

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSaveRfDeviceMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_RF_DEVICE_MASTER,
      data,

      onSuccess: () => {
        this.setState({ isOpen: false }, this.getRfDeviceMasterData());
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getRfDeviceMasterData);
  };

  onUpdateRfDeviceMasterData = (data) => {
    const previousData = getItemFromSessionStorage("previousRfDeviceMasterData");
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_RF_DEVICE_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState({ isOpen: false, editData: "" }, this.getRfDeviceMasterData);
      },
    });
  };

  editRfDeviceMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deleteRfDeviceMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_RF_DEVICE_MASTER,
      data: data,
      onSuccess: () => {
        this.getRfDeviceMasterData();
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getRfDeviceMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getRfDeviceMasterData
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getRfDeviceMasterData);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId,branchId} = this.props;
    const masterType = 62;
    const navUrl = `/auditScreen/${companyId}/${masterType}/${branchId}`;
    history.push(navUrl);
  };

  render() {
    const { rfDeviceData } = this.state;

    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add RF Device "} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Plant Name</th>
              <th>Plant Code</th>
              <th>RF Id</th>
              <th>Device Id</th>
              <th>Device Name</th>
              <th>Device Location</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {(rfDeviceData || []).map((rfDevice, sIndex) => (
              <tr key={`route_${sIndex}`}>
                <td>{rfDevice.plant_name}</td>
                <td>{rfDevice.plant_code}</td>
                <td>{rfDevice.rf_id}</td>
                <td>{rfDevice.device_id}</td>
                <td>{rfDevice.device_name}</td>
                <td>{rfDevice.device_location}</td>
                <td>
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editRfDeviceMaster(rfDevice)}
                  />
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteRfDeviceMaster(rfDevice)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddRfDeviceMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveRfDeviceMasterData}
            companyId={this.props.companyId}
            branchId={this.props.branchId}
            editData={this.state.editData}
            onUpdate={this.onUpdateRfDeviceMasterData}
            indentingMoves={this.props.indentingMoves}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zones: state.plantsDepots.zones,
    countryListData: state.master.countryList,
    productList: state.master.itemList,
    routeCodeList: state.home.routeCodes || [],
  };
};

export default connect(mapStateToProps)(withRouter(RfDeviceMaster));
